import { Cliente } from "./_index";
import { TipoUsuario } from '../rs/tipo-usuario';

export class Perfil {
    pais: string;
    negocio: string;
    idCliente: number;
    cliente: Cliente;
    idPerfil: number;
    perfil: string;
    idTipoUsuario: number;
    descripcion: string;
    niceName: string;
    tipoUsuario: TipoUsuario;
    tipoNodo: number;
    variablesLocales:any;
}